<template>
  <v-card class="mx-auto ma-2" max-width="400" min-width="300">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline">Applications</v-list-item-title>
        <v-list-item-subtitle class="display-3 mt-5">{{ summary.applications.total }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list class="transparent">
      <v-list-item>
        <v-list-item-title>Individual</v-list-item-title>
        <v-list-item-subtitle class="text-right">{{summary.applications.individual}}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>Tandem</v-list-item-title>
        <v-list-item-subtitle class="text-right">{{summary.applications.tandem}}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>Relay</v-list-item-title>
        <v-list-item-subtitle class="text-right">{{summary.applications.relay}}</v-list-item-subtitle>
      </v-list-item>
    </v-list>

  </v-card>
</template>

<script>
  export default {
    name: 'FCCCompetitionApplications',
    props: {
      summary: Object,
      reload: Function
    }
  }
</script>